import { render, staticRenderFns } from "./FiltroTipo.vue?vue&type=template&id=2c0d07c2&"
import script from "./FiltroTipo.vue?vue&type=script&lang=js&"
export * from "./FiltroTipo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Pipelines\\release\\06.04\\maintenance\\Fontes\\corp\\produto\\wes\\WebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c0d07c2')) {
      api.createRecord('2c0d07c2', component.options)
    } else {
      api.reload('2c0d07c2', component.options)
    }
    module.hot.accept("./FiltroTipo.vue?vue&type=template&id=2c0d07c2&", function () {
      api.rerender('2c0d07c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "content/components/Contabil/balancete/FiltroTipo.vue"
export default component.exports